import { Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DigitalAcceptanceModalComponent } from 'src/app/components/digital-acceptance-modal/digital-acceptance-modal.component';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { RejectedAlertComponent } from 'src/app/components/rejected-alert/rejected-alert.component';
import { RejectedReason } from 'src/app/models/rejected-reason-alert.models';
import { ITemplateQuestion } from 'src/app/models/templates.model';
import { AceiteDigitalService } from 'src/app/services/aceite-digital.service';
import { AuthService } from 'src/app/services/auth.service';
import { PdfService } from 'src/app/services/pdf.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';
import { SlideBaseComponent } from 'src/app/shared/slider/slide/slide-base.component';
import { getCurrency } from 'src/app/utils/helpers/currency.helper';
import { CO_STATUS_CONST } from 'src/app/utils/utils';

@Component({
  selector: 'hr-dynamic-question',
  templateUrl: './dynamic-question.component.html',
  styleUrls: ['./dynamic-question.component.scss'],
  providers: [FormBuilder],
})
export class DynamicQuestionComponent extends SlideBaseComponent {
  @ViewChild('olPdfAcceptance') olPdfAcceptance!: OlPdfAcceptanceComponent;
  override initialValue: ITemplateQuestion;
  cargo: string;
  salario: number;
  salaryType: 'horista' | 'mensalista';
  dataLimite: string;
  aceito = CO_STATUS_CONST.ACEITO;
  disabledBttns: boolean;
  isLoading = false;
  getCurrencyHelper = getCurrency;

  constructor(
    private formBuilder: FormBuilder,
    public propostaService: PropostaSalarialService,
    private dialog: MatDialog,
    private authService: AuthService,
    private aceiteDigitalService: AceiteDigitalService,
    private pdfService: PdfService,
  ) {
    super();
    this.cargo = this.propostaService.getView().cargo;
    this.salario = this.propostaService.getView().salario;
    this.salaryType = this.propostaService.getView().salaryType;
    const dataLimiteTimestamp = this.propostaService.getView().dataLimite;
    this.dataLimite = dataLimiteTimestamp
      ? dataLimiteTimestamp.toDate().toLocaleDateString()
      : null;
  }

  protected onInit(): void {
    this.disableBttns();
  }
  protected onDestroy(): void { }

  protected initForm(): void {
    this.form = this.formBuilder.group({
      slideName: [null, [Validators.required, Validators.maxLength(20)]],
      title: [null, [Validators.required, Validators.maxLength(80)]],
      description: [null, [Validators.required, Validators.maxLength(1500)]],
      backgroundImage: [null, [Validators.required]],
      backgroundImageUrl: [null, [Validators.required]],
      logoImage: [null, [Validators.required]],
      logoImageUrl: [null, [Validators.required]],
    });
  }

  disableBttns() {
    this.disabledBttns = this.authService.isPreview ? true : false;
  }

  async openModalRejectOffer() {
    this.dialog
      .open(RejectedAlertComponent, {
        panelClass: ['hr-modal', 'hr-thin-modal', 'hr-modal-reject'],
        backdropClass: 'hr-modal-backdrop-close',
      })
      .afterClosed()
      .subscribe(async (reason?: RejectedReason) => {
        if (reason) {
          this.isLoading = true;
          try {
            await this.propostaService.recusarOferta(reason);
            await this.pdfService.processAndUploadPdf(
              this.olPdfAcceptance,
              CO_STATUS_CONST.RECUSADO
            );
          } catch {
            // PDF failure does not block the rejection flow
          } finally {
            this.isLoading = false;
            this.nextSlideEmitter.emit(2);
          }
        }
      });
  }

  async onAcceptOffer() {
    if (!this.aceiteDigitalService.currentDigitalAcceptance) {
      this.isLoading = true;
      try {
        await this.propostaService.aceitarOferta(false);
        await this.pdfService.processAndUploadPdf(
          this.olPdfAcceptance,
          CO_STATUS_CONST.ACEITO
        );
      } catch {
        // PDF failure does not block the acceptance flow
      } finally {
        this.isLoading = false;
        this.nextSlideEmitter.emit();
      }
      return;
    }

    this.dialog
      .open(DigitalAcceptanceModalComponent, {
        width: '521px',
        height: '414px',
        panelClass: ['hr-confirmation-modal'],
        backdropClass: 'hr-modal-backdrop',
      })
      .afterClosed()
      .subscribe(async (accepted?: boolean) => {
        if (accepted) {
          this.isLoading = true;
          try {
            await this.propostaService.aceitarOferta(true);
            await this.pdfService.processAndUploadPdf(
              this.olPdfAcceptance,
              CO_STATUS_CONST.ACEITO
            );
          } catch {
            // PDF failure does not block the acceptance flow
          } finally {
            this.isLoading = false;
            this.nextSlideEmitter.emit();
          }
        }
      });
  }

  async onRejectOffer(reason: RejectedReason) {
    await this.propostaService.recusarOferta(reason);
    this.nextSlideEmitter.emit(2);
  }
}
